import { render, staticRenderFns } from "./DynamicTableBox.vue?vue&type=template&id=3e16ff79&scoped=true"
import script from "./DynamicTableBox.vue?vue&type=script&lang=js"
export * from "./DynamicTableBox.vue?vue&type=script&lang=js"
import style0 from "./DynamicTableBox.vue?vue&type=style&index=0&id=3e16ff79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16ff79",
  null
  
)

export default component.exports